import { render, staticRenderFns } from "./EditarProcedimentoOrigemDispensa.vue?vue&type=template&id=265f0f64&scoped=true"
import script from "./EditarProcedimentoOrigemDispensa.vue?vue&type=script&lang=ts"
export * from "./EditarProcedimentoOrigemDispensa.vue?vue&type=script&lang=ts"
import style0 from "./EditarProcedimentoOrigemDispensa.vue?vue&type=style&index=0&id=265f0f64&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "265f0f64",
  null
  
)

export default component.exports